import React from 'react';
// import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function N4(props) {
    const {
        t,
        // i18n,
        time = "",
        // name = "",
    } = props;

    return (
        <div>
            <h3>{t("messenger:notifications.N4.title")}</h3>
            <div className="sep-15" />
            <span className="dateTime">{time}</span>
            <div className="sep-10" />
            <div>
                {/*{t("messenger:notifications.N4.msg", {name: name})}*/}
                <div className="sep-20" />
                {t("messenger:general.thank_you_1")}
            </div>
        </div>
    )
}
export default withTranslation()(N4);